import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Cкидка 5% на поле.рф',
  description:
    'Подайте заявку на авансирование на поле.рф до 31 мая 2024 года, получите аванс и персональный промокод на скидку 5% на товары на поле.рф',
  button: {
    getDiscount: 'Получить скидку',
  },
} satisfies TMessages
